// extracted by mini-css-extract-plugin
export default {"EmptyList":"ProjectList_EmptyList__vTzDR","EmptyList_Text":"ProjectList_EmptyList_Text__bIZlG"};